// extracted by mini-css-extract-plugin
export default {"container":"scrollable-list_container__Yk3Iq"};